export default {
    alarmSummary(state) {
        return state.alarmSummary;
    },
    hasAlarms(state) {
        return state.alarmSummary && state.alarmSummary.length > 0;
    },
    allAlarms(state) {
        return state.allAlarms;
    },
    individualAlarms(state) {
        return state.individualAlarms;
    },
    alarmTypesForSelect(state) {
        const alarmTypes = [];

        for (const alarmType of state.alarmTypes) {
            alarmTypes.push({
                id: `${alarmType.id}`,
                text: alarmType.title
            });
        }

        return alarmTypes;
    },
    alarmAccountsForSelect(state) {
        return state.alarmAccounts.map(account => ({
            id: `${account.id}`,
            text: account.feederName || account.accountUserName
        }));
    },
    rules(state) {
        return state.rules;
    },
    descriptions(state) {
        return state.descriptions;
    }
}